import { render, staticRenderFns } from "./bottomDots.vue?vue&type=template&id=0589ff79&scoped=true&"
import script from "./bottomDots.vue?vue&type=script&lang=js&"
export * from "./bottomDots.vue?vue&type=script&lang=js&"
import style0 from "./bottomDots.vue?vue&type=style&index=0&id=0589ff79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0589ff79",
  null
  
)

export default component.exports